import { extractIndividualSchemaField, extractCaseBasedSchemaField } from
  'v2/modules/withRunForm/utils/signal';
import _ from "lodash";

export const updateCaseIndexInOperand = (operand, newCaseIndex, currentCaseIndex) => {
  if (!_.startsWith(operand, "case.")) return operand;

  const { label, field } = extractIndividualSchemaField(operand || '');
  if (_.isEmpty(label)) {
    const { caseIndex: operandCaseIdx, field } = extractCaseBasedSchemaField(operand || '');
    if (_.parseInt(currentCaseIndex) !== _.parseInt(operandCaseIdx)) return operand;
    return ['case', newCaseIndex, field].join('.');
  }
  return ['case', newCaseIndex, 'leg', label, field].join('.');
}

export const updateCaseIndexInSignals = (signals, newCaseIndex, currentCaseIndex) => {
  return signals.map((signal) => {
    const { leftOperand, rightOperand } = signal;

    return {
      ...signal,
      leftOperand: updateCaseIndexInOperand(leftOperand, newCaseIndex, currentCaseIndex),
      rightOperand: updateCaseIndexInOperand(rightOperand, newCaseIndex, currentCaseIndex),
    };
  });
};
